export default __webpack_public_path__ + "static/media/03.93c20400.webp";